import { c as _c } from "react/compiler-runtime";
import { Chip } from "@flat-ui";
import { FaroCoreApiUtils } from "@stellar/core-api-client";
import { DEFAULT_TEXT_FONT_SIZE } from "@styles/common-styles";
import { useMemo } from "react";

/** Matches the body text of the table cells around the chip */
const STATUS_CHIP_SX = {
  "& .MuiChip-label": {
    fontSize: DEFAULT_TEXT_FONT_SIZE
  }
};

/**
 * Returns the registration status of a team member as a chip
 * If the identity is equal to id, then the user is registered and active
 */
export function MemberStatus(t0) {
  const $ = _c(4);
  const {
    member
  } = t0;
  let t1;
  if ($[0] !== member) {
    t1 = FaroCoreApiUtils.Member.isMemberActive(member) ? {
      label: FaroCoreApiUtils.Member.getMemberStatus(member),
      color: "primary",
      tooltip: "The invited member successfully created an account"
    } : {
      label: FaroCoreApiUtils.Member.getMemberStatus(member),
      color: "warning",
      tooltip: "The invited member has not yet created an account"
    };
    $[0] = member;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const statusChipProps = t1;
  let t2;
  if ($[2] !== statusChipProps) {
    t2 = <Chip {...statusChipProps} sx={STATUS_CHIP_SX} />;
    $[2] = statusChipProps;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}